/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntCalculationDataTransferObject } from './IntCalculationDataTransferObject';
import {
    IntCalculationDataTransferObjectFromJSON,
    IntCalculationDataTransferObjectFromJSONTyped,
    IntCalculationDataTransferObjectToJSON,
    IntCalculationDataTransferObjectToJSONTyped,
} from './IntCalculationDataTransferObject';
import type { MoneyCalculationDataTransferObject } from './MoneyCalculationDataTransferObject';
import {
    MoneyCalculationDataTransferObjectFromJSON,
    MoneyCalculationDataTransferObjectFromJSONTyped,
    MoneyCalculationDataTransferObjectToJSON,
    MoneyCalculationDataTransferObjectToJSONTyped,
} from './MoneyCalculationDataTransferObject';

/**
 * 
 * @export
 * @interface SingleSourceData
 */
export interface SingleSourceData {
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    averageOrderValueNet?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    averageOrderValueGross?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {string}
     * @memberof SingleSourceData
     */
    sourceName?: string;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    spendMarketing?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {IntCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    orderAmountNet?: IntCalculationDataTransferObject;
    /**
     * 
     * @type {IntCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    orderAmountGross?: IntCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    turnoverNet?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    turnoverGross?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    spendGoodsNet?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    spendGoodsGross?: MoneyCalculationDataTransferObject;
}

/**
 * Check if a given object implements the SingleSourceData interface.
 */
export function instanceOfSingleSourceData(value: object): value is SingleSourceData {
    return true;
}

export function SingleSourceDataFromJSON(json: any): SingleSourceData {
    return SingleSourceDataFromJSONTyped(json, false);
}

export function SingleSourceDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleSourceData {
    if (json == null) {
        return json;
    }
    return {
        
        'averageOrderValueNet': json['averageOrderValueNet'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['averageOrderValueNet']),
        'averageOrderValueGross': json['averageOrderValueGross'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['averageOrderValueGross']),
        'sourceName': json['sourceName'] == null ? undefined : json['sourceName'],
        'spendMarketing': json['spendMarketing'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['spendMarketing']),
        'orderAmountNet': json['orderAmountNet'] == null ? undefined : IntCalculationDataTransferObjectFromJSON(json['orderAmountNet']),
        'orderAmountGross': json['orderAmountGross'] == null ? undefined : IntCalculationDataTransferObjectFromJSON(json['orderAmountGross']),
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['turnoverGross']),
        'spendGoodsNet': json['spendGoodsNet'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['spendGoodsNet']),
        'spendGoodsGross': json['spendGoodsGross'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['spendGoodsGross']),
    };
}

export function SingleSourceDataToJSON(json: any): SingleSourceData {
    return SingleSourceDataToJSONTyped(json, false);
}

export function SingleSourceDataToJSONTyped(value?: SingleSourceData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'averageOrderValueNet': MoneyCalculationDataTransferObjectToJSON(value['averageOrderValueNet']),
        'averageOrderValueGross': MoneyCalculationDataTransferObjectToJSON(value['averageOrderValueGross']),
        'sourceName': value['sourceName'],
        'spendMarketing': MoneyCalculationDataTransferObjectToJSON(value['spendMarketing']),
        'orderAmountNet': IntCalculationDataTransferObjectToJSON(value['orderAmountNet']),
        'orderAmountGross': IntCalculationDataTransferObjectToJSON(value['orderAmountGross']),
        'turnoverNet': MoneyCalculationDataTransferObjectToJSON(value['turnoverNet']),
        'turnoverGross': MoneyCalculationDataTransferObjectToJSON(value['turnoverGross']),
        'spendGoodsNet': MoneyCalculationDataTransferObjectToJSON(value['spendGoodsNet']),
        'spendGoodsGross': MoneyCalculationDataTransferObjectToJSON(value['spendGoodsGross']),
    };
}

